// Generated illustration assets matching the Rangeet children's-book aesthetic.
export const ASSETS = {
  mobileBg:
    'https://cdn.magicpatterns.com/patterns/generated-images/68f07e5b-39e0-49d5-b86b-1a8494526b5d.jpg',
  ecology:
    'https://cdn.magicpatterns.com/patterns/generated-images/71ac1368-27c7-4bd3-9969-784805a44faa.jpg',
  society:
    'https://cdn.magicpatterns.com/patterns/generated-images/6a0b58ce-95b5-4a05-8a5a-93a77335d372.jpg',
  self: 'https://cdn.magicpatterns.com/patterns/generated-images/69085d74-9a90-4f30-9bf9-68c211ed10fe.jpg',
  avatar:
    'https://cdn.magicpatterns.com/patterns/generated-images/ad1d64f0-d301-4dfd-bab7-d9f0456c65c9.jpg',
} as const

export type Lang = 'en' | 'hi' | 'mr'

export const LANG_LABEL: Record<Lang, string> = {
  en: 'English',
  hi: 'हिंदी',
  mr: 'मराठी',
}
